// cspell:disable
/** biome-ignore-all assist/source/organizeImports: reason */
/** biome-ignore-all lint/a11y/noStaticElementInteractions: reason */
/** biome-ignore-all lint/correctness/noUnusedVariables: reason */
/** biome-ignore-all lint/a11y/useKeyWithClickEvents: reason */
/** biome-ignore-all lint/correctness/noUnusedImports: reason */

import React, { useState } from 'react';
import { Link, NavLink, useHistory } from 'react-router-dom';

import release from '../../../config/release.json';
import { useAuth, useUser } from '../../../context/auth';
import NavigationItems from '../NavigationItems/NavigationItems';
import NavIcon from '../navIcon';

import {
	FaArrowLeft,
	FaArrowRight,
	FaBuilding,
	FaClipboard,
	FaDatabase,
	FaHistory,
	FaLifeRing,
	FaTachometerAlt,
	FaTint
} from '../../ui/icons';

import './SideDrawer.css';

const SideDrawer = () => {
	const history = useHistory();
	const { claims } = useAuth();
	const profile = useUser();

	const [showMobileMenu, setShowMobileMenu] = useState(true);
	const [showMenu, setShowMenu] = useState(true);

	const mobileMenuToggleHandler = () => {
		setShowMobileMenu((prev) => !prev);
	};

	return (
		<div
			style={{
				minHeight: '100vh',
				overflow: 'auto',
				gridColumn: 'span 1 / span 1'
			}}
		>
			{/* MINI DRAWER */}
			<div
				style={{
					backgroundColor: '#1D1D3B',
					height: '100%',
					color: 'white',
					display: !showMenu ? 'flex' : 'none',
					flexDirection: 'column'
				}}
			>
				<div
					style={{
						flex: 1,
						padding: '1rem 0rem',
						display: 'flex',
						flexDirection: 'column',
						fontSize: '1.5rem',
						gap: '3rem'
					}}
				>
					<NavLink
						to={'/dashboard'}
						exact
						style={{
							color: 'white',
							padding: '0rem 1rem',
							width: '100%',
							display: 'flex',
							justifyContent: 'center'
						}}
					>
						<FaTachometerAlt />
					</NavLink>

					<NavLink
						to="/kegs-list"
						exact
						onClick={() => {
							setShowMenu(true);
						}}
						style={{
							color: 'white',
							padding: '0rem 1rem',
							width: '100%',
							display: 'flex',
							justifyContent: 'center'
						}}
					>
						<FaDatabase />
					</NavLink>

					<NavLink
						to="/keg-fill"
						onClick={() => {
							setShowMenu(true);
						}}
						exact
						style={{
							color: 'white',
							padding: '0rem 1rem',
							width: '100%',
							display: 'flex',
							justifyContent: 'center'
						}}
					>
						<FaTint />
					</NavLink>

					<div
						onClick={() => {
							setShowMenu(true);
						}}
						style={{
							color: 'white',
							padding: '0rem 1rem',
							width: '100%',
							display: 'flex',
							justifyContent: 'center'
						}}
					>
						<FaHistory />
					</div>

					<NavLink
						to="/reports/dash"
						style={{
							color: 'white',
							padding: '0rem 1rem',
							width: '100%',
							display: 'flex',
							justifyContent: 'center'
						}}
					>
						<FaClipboard />
					</NavLink>
					<div
						onClick={() => {
							setShowMenu(true);
						}}
						style={{
							color: 'white',
							padding: '0rem 1rem',
							width: '100%',
							display: 'flex',
							justifyContent: 'center'
						}}
					>
						<FaBuilding />
					</div>

					<NavLink
						to="/help"
						style={{
							color: 'white',
							padding: '0rem 1rem',
							width: '100%',
							display: 'flex',
							justifyContent: 'center'
						}}
					>
						<FaLifeRing />
					</NavLink>
				</div>

				<div
					onClick={() => {
						setShowMenu(true);
					}}
					style={{
						width: '100%',
						display: 'flex',
						justifyContent: 'end',
						color: 'white',
						padding: '1rem 1rem',
						cursor: 'pointer'
					}}
				>
					{/* size: lg */}
					<FaArrowRight size={20} />
				</div>
			</div>

			{/* LARGE DRAWER */}
			<div
				style={{
					minHeight: '100vh',
					// transition: 'width 35s ease-in-out',
					// width: showMenu ? 'auto' : '0rem',
					display: showMenu ? 'grid' : 'none'
				}}
				className="side-drawer"
			>
				<div className="side-drawer-header">
					<div className="logo">
						<Link to="/">
							<img
								src="/assets/images/keg-tracker-logo.svg"
								alt="Keg Tracker"
							/>
						</Link>
					</div>
					<div className="mobile-nav-trigger" onClick={mobileMenuToggleHandler}>
						<NavIcon open={showMobileMenu} />
					</div>
				</div>
				<NavigationItems
					profile={profile}
					claims={claims}
					visible={showMobileMenu}
					toggle={mobileMenuToggleHandler}
				/>
				<div
					onClick={() => {
						setShowMenu(false);
					}}
					style={{
						width: '100%',
						display: 'flex',
						justifyContent: 'end',
						color: 'white',
						padding: '1rem 1rem',
						cursor: 'pointer'
					}}
				>
					{/* size: lg */}
					<FaArrowLeft size={20} />
				</div>

				<div className="version">Version {release.versionClient}</div>

				<div className="product-of">
					<h3>A product of</h3>

					<a
						href="https://beverageinsights.co"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img
							src="/assets/images/beverage-insights-logo.svg"
							alt="Beverage Insights"
						/>
					</a>
				</div>
			</div>
		</div>
	);
};

export default SideDrawer;
